interface IStartDialogFile {
  fileId: number;
  name: string;
}

interface IStartDialogFromContact {
  botId: number;
  contactId: number;
  userId: number;
  message?: string;
  file?: IStartDialogFile | null;
  forwardMessageId?: number;
  forwardSourceDialogId?: number;
}

type StartDialogResult = { status: number; response: any | null } | never;

export default () => {
  const StartDialogFromContact = async (
    data: IStartDialogFromContact
  ): Promise<StartDialogResult> => {
    const {
      userId,
      botId,
      contactId,
      message,
      file,
      forwardMessageId,
      forwardSourceDialogId
    } = data;

    const body: any = { botId, contactId };

    if (message && message.trim().length > 0) body.message = message;
    if (file) body.file = file;
    if (forwardMessageId) body.forwardMessageId = forwardMessageId;
    if (forwardSourceDialogId) body.forwardSourceDialogId = forwardSourceDialogId;

    const res = await fetch(`/api/dialogs/start-from-contact/${userId}`, {
      method: "POST",
      credentials: "same-origin",
      mode: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });

    if (res.status === 204) {
      return { status: res.status, response: null };
    }

    const json = await res.json().catch(() => null);

    return { status: res.status, response: json };
  };

  return { StartDialogFromContact };
};
